import { MatPaginator } from "@angular/material/paginator";
import {
  AppSidenavItem,
  MessageService,
  MustBeAmbiguouslyNullable,
  NullPart,
  hasValue,
} from "common";
import { HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";

export function hasValueFn<T, A>(
  value: MustBeAmbiguouslyNullable<T>,
  thenFn: (value: NonNullable<MustBeAmbiguouslyNullable<T>>) => A,
): A | NullPart<T> {
  return hasValue(value)
    ? thenFn(value)
    : (value as NullPart<MustBeAmbiguouslyNullable<T>>);
}

export function addDefaultAppSidenavItemOptions(
  items: (Omit<AppSidenavItem, "hidden"> & { hidden?: boolean })[],
  defaultOptions: {
    hidden?: boolean;
    query?: {
      sort?: string;
    };
  } = {
      hidden: false,
      query: {
        sort: undefined,
      },
    },
): AppSidenavItem[] {
  return items.map(item => ({
    ...defaultOptions,
    ...item,
    query: { ...defaultOptions.query, ...item.query },
    subitems: item.subitems?.map(subitem => ({
      ...defaultOptions,
      ...subitem,
      query: { ...defaultOptions.query, ...subitem.query },
    })),
  })) as AppSidenavItem[];
}

export function setPaginatorFromQueryVars(paginator: MatPaginator, query: any) {
  paginator.pageSize = query.limit;
  paginator.pageIndex = Math.floor(query.skip / query.limit);
}

export function getErrorForMessageService(error: HttpErrorResponse | string) {
  if (error instanceof HttpErrorResponse && error.status === 0) {
    return "Please try again.";
  } else {
    return error;
  }
}

export function defaultObservableError(
  error: HttpErrorResponse | string,
  messageService: MessageService,
) {
  messageService.error(getErrorForMessageService(error));
  return throwError(error);
}

export function defaultObservableErrorHandler(messageService: MessageService) {
  return (error: HttpErrorResponse | string) =>
    defaultObservableError(error, messageService);
}
